var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog411(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_411",
    "data-name": 411,
    className: "cls-1",
    d: "M78.88,54.37c-.5,22.09-9.23,42.95-27,43.93C32.59,99.37,23.67,74.53,21.52,56.92c-2.29-18.86,4.57-54,26-55.22C68.57.49,79.46,28.29,78.88,54.37Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog411);
export default __webpack_public_path__ + "static/media/dog_411.b5ceaba51739ca1e056d1b12a8ab8bac.svg";
export { ForwardRef as ReactComponent };